<div>
  <div class="mat-app-background">
    <app-nav class="app-navbar"></app-nav>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>
